import React from "react";

/**
 * Coloured badge for subscription plan tiers.
 * Handles: freemium, individual, business, enterprise, professional.
 */
const planStyles = {
  freemium:     "bg-green-100  text-green-700  border-green-200",
  individual:   "bg-gray-100   text-gray-600   border-gray-200",
  business:     "bg-orange-100 text-orange-700 border-orange-200",
  enterprise:   "bg-purple-100 text-purple-700 border-purple-200",
  professional: "bg-blue-100   text-blue-700   border-blue-200",
  // legacy aliases
  starter:      "bg-gray-100   text-gray-600   border-gray-200",
  free:         "bg-green-100  text-green-700  border-green-200",
};

const PlanBadge = ({ plan = "" }) => {
  const key   = plan.toLowerCase();
  const style = planStyles[key] ?? "bg-gray-100 text-gray-500 border-gray-200";
  const label = plan ? plan.charAt(0).toUpperCase() + plan.slice(1) : "—";

  return (
    <span className={`inline-flex px-2.5 py-0.5 rounded-full text-xs font-semibold border capitalize whitespace-nowrap ${style}`}>
      {label}
    </span>
  );
};

export default PlanBadge;
